import { render } from "./EditPermissionGroup.vue?vue&type=template&id=d71ee0e4&scoped=true&ts=true"
import script from "./EditPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./EditPermissionGroup.vue?vue&type=script&lang=ts"

import "./EditPermissionGroup.vue?vue&type=style&index=0&id=d71ee0e4&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71ee0e4"]])

export default __exports__